<template>
  <div>
    <!-- پوشش تیره روی موبایل -->
    <div
      v-if="open && isNarrow"
      class="bndbs-sidenav-backdrop"
      @click="close"
    ></div>

    <nav
      class="bndbs-sidenav"
      :class="{ open: open }"
      aria-label="منوی اصلی"
    >
      <div class="sidenav-header">
        <img src="/img/logo.png" alt="لوگو" class="sidenav-logo" />
        <div class="sidenav-title">پنل پشتیبانی برنامه‌نویسان دانش برتر سهند</div>
      </div>

      <ul class="sidenav-list list-unstyled mb-0">
        <li>
          <router-link to="/" class="sidenav-link" @click="onNavigate">
            <i class="fas fa-tachometer-alt fa-fw"></i><span>داشبرد</span>
          </router-link>
        </li>

        <li v-for="(cat, ci) in categories" :key="ci" class="sidenav-cat">
          <button
            type="button"
            class="sidenav-cat-toggle"
            :aria-expanded="expanded[ci] ? 'true' : 'false'"
            @click="toggleCat(ci)"
          >
            <i :class="'fas fa-fw ' + cat.icon"></i>
            <span>{{ cat.name }}</span>
            <i
              class="fas fa-chevron-down chev"
              :class="{ rot: expanded[ci] }"
            ></i>
          </button>
          <ul v-show="expanded[ci]" class="sidenav-sublist list-unstyled">
            <li v-for="(item, ii) in cat.items" :key="ii">
              <router-link
                :to="item.to"
                class="sidenav-link sub"
                @click="onNavigate"
              >
                <i class="fas fa-fw" :class="item.icon || 'fa-angle-left'"></i>
                <span>{{ item.label }}</span>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "SideNav",
  data() {
    return {
      width: typeof window !== "undefined" ? window.innerWidth : 1400,
      // فقط دسته‌ای که مسیر جاری در آن است باز می‌ماند؛ syncExpanded آن را پر می‌کند
      expanded: [],
    };
  },
  computed: {
    ...mapState(["sidenav"]),
    userId() {
      return this.$store.state.user.UserId;
    },
    open() {
      return this.sidenav;
    },
    isNarrow() {
      return this.width < 1200;
    },
    categories() {
      const uid = this.userId;
      return [
        {
          name: "تنظیمات کاربری",
          icon: "fa-user-cog",
          items: [
            { label: "پروفایل", to: "/profile/" + uid + "/edit", icon: "fa-id-card" },
            {
              label: "تغییر رمز عبور",
              to: "/account/" + uid + "/changePassword",
              icon: "fa-key",
            },
          ],
        },
        {
          name: "پشتیبانی",
          icon: "fa-headset",
          items: [
            { label: "تیکت‌ها", to: "/tickets", icon: "fa-inbox" },
            { label: "تیکت جدید", to: "/tickets/new", icon: "fa-plus" },
          ],
        },
        {
          name: "امور مالی",
          icon: "fa-file-invoice-dollar",
          items: [
            { label: "فاکتورهای من", to: "/invoices", icon: "fa-file-invoice" },
            { label: "تسویه فاکتور", to: "/request/Invoice", icon: "fa-money-check" },
            { label: "کیف پول", to: "/wallet", icon: "fa-wallet" },
            {
              label: "شارژ کیف پول",
              to: "/request/WalletCharge",
              icon: "fa-plus-circle",
            },
          ],
        },
        {
          name: "سرویس‌ها",
          icon: "fa-cubes",
          items: [
            { label: "سرویس‌های من", to: "/services", icon: "fa-list" },
            {
              label: "ثبت سفارش جدید سرویس",
              to: "/Request/Service",
              icon: "fa-cart-plus",
            },
            {
              label: "ثبت‌نام دوره آموزشی",
              to: "/Request/Course",
              icon: "fa-graduation-cap",
            },
            { label: "ثبت سفارش پکیج", to: "/Request/Package", icon: "fa-box" },
            {
              label: "ثبت سفارش محصول آماده",
              to: "/Request/Product",
              icon: "fa-cube",
            },
          ],
        },
        // منوی «خریدها» فعلاً مخفی است (به‌درخواست کارفرما)
        // {
        //   name: "خریدها",
        //   icon: "fa-briefcase",
        //   items: [
        //     { label: "محصولات", to: "/Download/Products" },
        //     { label: "دوره‌ها", to: "/Download/Courses" },
        //     { label: "پکیج‌ها", to: "/Download/Packages" },
        //   ],
        // },
      ];
    },
  },
  methods: {
    ...mapActions(["toggleSideNav"]),
    close() {
      this.toggleSideNav(false);
    },
    toggleCat(i) {
      this.expanded.splice(i, 1, !this.expanded[i]);
    },
    onNavigate() {
      if (this.isNarrow) this.close();
    },
    setWidth() {
      this.width = window.innerWidth;
      this.toggleSideNav(this.width >= 1200);
    },
    // فقط دسته‌ای که آیتم آن با مسیر جاری می‌خوانَد باز شود، بقیه بسته
    syncExpanded() {
      const path = decodeURIComponent(
        (this.$route && this.$route.path) || "/"
      ).toLowerCase();

      const byFullPath = this.categories.map((cat) =>
        cat.items.some((it) => {
          const to = String(it.to || "").toLowerCase();
          return to.length > 1 && (path === to || path.startsWith(to + "/"));
        })
      );
      if (byFullPath.some(Boolean)) {
        this.expanded = byFullPath;
        return;
      }

      // fallback: تطبیق بر اساس نخستین بخش مسیر (مثلاً /ticket/5 → تیکت‌ها)
      const seg = path.split("/").filter(Boolean)[0] || "";
      this.expanded = this.categories.map((cat) =>
        cat.items.some((it) => {
          const t =
            String(it.to || "").toLowerCase().split("/").filter(Boolean)[0] || "";
          return t && (t === seg || seg.startsWith(t) || t.startsWith(seg));
        })
      );
    },
  },
  watch: {
    $route() {
      this.syncExpanded();
    },
  },
  mounted() {
    this.setWidth();
    this.syncExpanded();
    window.addEventListener("resize", this.setWidth);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setWidth);
  },
};
</script>

<style scoped>
.bndbs-sidenav {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: var(--bndbs-sidenav-w, 240px);
  background: #2b2f3a;
  color: #cfd2da;
  z-index: 1040;
  overflow-y: auto;
  transform: translateX(100%);
  transition: transform 0.25s ease;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.15);
}
.bndbs-sidenav.open {
  transform: translateX(0);
}
.bndbs-sidenav-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1035;
}
.sidenav-header {
  padding: 1rem;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.sidenav-logo {
  max-height: 44px;
  margin-bottom: 0.5rem;
}
.sidenav-title {
  font-size: 12px;
  opacity: 0.8;
  line-height: 1.6;
}
.sidenav-link {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.7rem 1rem;
  color: #cfd2da;
  text-decoration: none;
  font-size: 14px;
}
.sidenav-link.sub {
  padding-right: 1.6rem;
  font-size: 13px;
}
.sidenav-link.sub > .fa-fw {
  font-size: 11px;
  opacity: 0.75;
}
.sidenav-link:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}
/* روتر با linkActiveClass:"active" کلاس فعال را «active» می‌گذارد (نه router-link-active) */
.sidenav-link.active,
.sidenav-link.router-link-active {
  background: rgba(243, 91, 33, 0.18);
  color: #fff;
  font-weight: 700;
  border-inline-start: 3px solid var(--bndbs-primary, #f35b21);
}
.sidenav-link.sub.active,
.sidenav-link.sub.router-link-active {
  padding-right: calc(1.6rem - 3px);
}
.sidenav-cat-toggle {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  width: 100%;
  border: 0;
  background: transparent;
  color: #aeb2bd;
  padding: 0.7rem 1rem;
  font-size: 13px;
  text-align: right;
}
.sidenav-cat-toggle .chev {
  margin-right: auto;
  font-size: 11px;
  transition: transform 0.2s;
}
.sidenav-cat-toggle .chev.rot {
  transform: rotate(180deg);
}
</style>
